import React, { useState } from "react";
import { useMutation } from "@apollo/react-hooks";
import { gql } from "apollo-boost";
import { Button, Modal, Checkbox, message } from "antd";

type UpdateAllSessionsFromScenarioButtonProps = {
  children?: never;
  scenarioId: string;
  label: string;
};

const UPDATE_MUTATION = gql`
  mutation($scenarioId: UUID!, $restartServers: Boolean!) {
    update: updateAllSessionsFromScenario(
      input: { scenarioId: $scenarioId, restartServers: $restartServers }
    ) {
      sessions {
        id
        pin
        masterPassword
        definition
        isActive
      }
      errors {
        key
        message
      }
    }
  }
`;

const UpdateAllSessionsFromScenarioButton: React.FC<UpdateAllSessionsFromScenarioButtonProps> = ({
  scenarioId,
  label,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [restartServers, setRestartServers] = useState(false);
  const [busy, setBusy] = useState(false);
  const [updateMutation] = useMutation(UPDATE_MUTATION);

  const handleButtonClick = () => setShowModal(true);
  const handleCheckboxChange = (e: any) => setRestartServers(e.target.checked);
  const handleOk = async () => {
    setBusy(true);
    try {
      const { data } = await updateMutation({
        variables: { scenarioId, restartServers },
      });
      data.update.sessions.forEach((session: any) =>
        message.success(
          `Session with PIN ${session.pin} has been updated${
            restartServers ? " and restarted" : ""
          }.`,
          10
        )
      );
    } catch (e) {
      message.error("Updating sessions failed");
    }
    setBusy(false);
    setShowModal(false);
    setRestartServers(false);
  };
  const handleCancel = () => setShowModal(false);

  return (
    <>
      <Button onClick={handleButtonClick}>{label}</Button>
      <Modal
        visible={showModal}
        onOk={handleOk}
        okButtonProps={{ disabled: busy }}
        okText="Yes"
        okType="danger"
        onCancel={handleCancel}
      >
        <p>Do you really want to update all dependent sessions?</p>
        <p>
          <Checkbox checked={restartServers} onChange={handleCheckboxChange}>
            Restart servers? <strong>(optionally)</strong>
          </Checkbox>
        </p>
      </Modal>
    </>
  );
};

export default UpdateAllSessionsFromScenarioButton;
